<template>
    <div v-if="model" class="model-info wrapper model-info-appication-finish">
        <div class="btn-close-preview" @click="hideModel()" style="cursor: pointer"></div>
        <div class="breadcrumb">
            <span @click="hideModel()" style="cursor: pointer">OVERVIEW</span> > <strong class="orange">{{ model.Voornaam }} {{ model.Achternaam_letter }}</strong></div>
        <h1>{{ model.Voornaam }} {{ model.Achternaam_letter }}</h1>
        <div class="info">
            <table class="column" v-if="windowWidth > 400">
                <tr>
                    <td>Model ID</td>
                    <td>: {{ model.Referentienummer }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.category') }}</td>
                    <td>: {{  model.Klasse}} <span v-if="proposalId"> - {{ model.Nivo }}</span></td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.age') }}</td>
                    <td>: {{ model.Leeftijd }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.length') }}</td>
                    <td>: {{ model.Lengte }}</td>
                </tr>
            </table>
            <table class="column" v-if="windowWidth > 400">
                <tr>
                    <td>{{ trans('talents.profile.ready_to_wear') }}</td>
                    <td>: {{ model.Confectie }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.shoe_size') }}</td>
                    <td>: {{ model.Schoen }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.hair_colour') }}</td>
                    <td>: {{ model.Haarkleur }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.eye_colour') }}</td>
                    <td>: {{ model.Ogen }}</td>
                </tr>
            </table>
            <table class="column" v-if="windowWidth < 400">
                <tr>
                    <td>{{ trans('talents.profile.category') }}</td>
                    <td>: {{ model.Klasse }} <span v-if="proposalId"> - {{ model.Nivo }}</span></td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.age') }}</td>
                    <td>: {{ model.Leeftijd }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.length') }}</td>
                    <td>: {{ model.Lengte }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.ready_to_wear') }}</td>
                    <td>: {{ model.Confectie }}</td>
                </tr>
                <tr>
                    <td>{{ trans('talents.profile.shoe_size') }}</td>
                    <td>: {{ model.Schoen }}</td>
                </tr>
            </table>
            <div class="column" v-if="windowWidth < 400"></div>
            <table class="column">
                <tr>
                    <td colspan="2" class="btns"><a :href="'/model/sedcard/'+model.ID_Model" class="btn-black btn-download" :data-id="model.ID_Model">{{ trans('talents.profile.download_sedcard') }}</a></td>
                </tr>
                <tr>
                    <td class="data">{{ trans('talents.profile.last_update') }}</td>
                    <td class="data">{{ model.last_change_to_model }}</td>
                </tr>
                <tr>
                    <td class="data">{{ trans('talents.profile.last_update_pics') }}</td>
                    <td class="data">{{ model.last_changed_foto }}</td>
                </tr>
            </table>
        </div>
        <div class="images" v-if="modelfotos">
            <div class="row">
                <div class="model-image"><img v-if="modelfotos[0]" v-lazy="'/model-image/'+modelfotos[0].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+ model.Achternaam_letter"></div>
                <div class="model-image"><img v-if="modelfotos[1]" v-lazy="'/model-image/'+modelfotos[1].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+ model.Achternaam_letter"></div>
            </div>
            <div class="row">
                <div class="model-image white"><img v-if="modelfotos[2]" v-lazy="'/model-image/'+modelfotos[2].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+ model.Achternaam_letter"></div>
                <div class="model-image white"><img v-if="modelfotos[3]" v-lazy="'/model-image/'+modelfotos[3].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+ model.Achternaam_letter"></div>
            </div>
            <div class="row"  v-if="windowWidth > 400">
                <div class="model-image white"><img v-if="modelfotos[4] && modelfotos[4].ID_Foto" v-lazy="'/model-image/'+modelfotos[4].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+ model.Achternaam_letter"></div>
                <div class="model-image white"><img v-if="modelfotos[5] && modelfotos[5].ID_Foto" v-lazy="'/model-image/'+modelfotos[5].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+ model.Achternaam_letter"></div>
            </div>
            <div class="row"  v-if="windowWidth > 400">
                <div class="model-image white"><img v-if="modelfotos[6] && modelfotos[6].ID_Foto" v-lazy="'/model-image/'+modelfotos[6].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+ model.Achternaam_letter"></div>
                <div class="model-image white"><img v-if="modelfotos[7] && modelfotos[4].ID_Foto" v-lazy="'/model-image/'+modelfotos[7].ID_Foto+'.jpg'" :alt="model.Voornaam +' '+ model.Achternaam_letter"></div>
            </div>
        </div>
    </div>
</template>
<script type='text/babel'>
    export default {
        props: ['model'],

        computed: {

            applicationId() {
                return this.$store.getters.applicationId()
            },
            proposalId() {
                return this.$store.getters.proposalId()
            },
            backUrl() {
               return  this.applicationId && this.proposalId ? '/aanvraag/'+this.applicationId+'/'+this.proposalId : '/'
            },
            modelfotos() {
                return _.uniqBy(_.toArray(this.model.fotos), 'id');
            },
            showAllImages() {
                if (this.model.Klasse === 'Acteur' || this.model.Specialiteit === 'Hostessen' || this.model.Specialiteit === 'Families' || this.model.Specialiteit === 'Handmodellen') {
                    return false;
                } else {
                    return true
                }
            },

        },
        methods: {
            hideModel() {
                alert('123')
                let blah = document.getElementById('models-detail-overlay');
                document.body.classList.remove('noscroll')
                TweenMax.to(blah, 0.3, {top: '100vh'})
                this.$parent.$emit('removeModel')

            },
        },
    };
</script>
